import React, { useEffect, useState } from 'react';
import { Popup, Selector, Toast } from 'antd-mobile';
import axios from 'axios';
import API_ROUTES from '../../api';

const SIGNUP_OPTIONS = [
    { label: '上场队员', value: 0 },
    { label: '主裁', value: 1 },
    { label: '边裁', value: 2 },
    { label: 'VAR', value: 3 },
    { label: '观众', value: 4 },
];

// 懒人、待定和请假成员共用同一底部面板完成身份与队伍选择。
const LazySignupPopup = ({ visible, user, avatar, gameDetail, teams, onClose, onUpdated }) => {
    const [gameType, setGameType] = useState(null);
    const [gameTeam, setGameTeam] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const isStatusChange = user?.gameType === 5 || user?.gameType === 6;
    const currentStatus = user?.gameType === 5
        ? `当前：请假${user.remark ? ` · ${user.remark}` : ''}`
        : user?.gameType === 6 ? '当前：待定'
            : user?.gameType === 7 ? '当前：鸽子' : '当前尚未报名';

    useEffect(() => {
        if (!user) return;
        setGameType(null);
        setGameTeam(null);
    }, [user]);

    const submit = async () => {
        if (gameType === null) {
            Toast.show({ content: '请选择报名身份', icon: 'fail' });
            return;
        }
        if (gameType === 0 && !gameTeam) {
            Toast.show({ content: '请选择所属队伍', icon: 'fail' });
            return;
        }

        setSubmitting(true);
        try {
            const data = gameType === 0
                ? { gameId: gameDetail.id, memberId: user.id, gameType: 0, gameTeam, flag: 1 }
                : { gameId: gameDetail.id, memberId: user.id, gameType, remark: null };
            const response = await axios.post(API_ROUTES.game_join, data, {});
            if (response.data.code === 200) {
                Toast.show({ content: isStatusChange ? '报名状态已更新！' : '报名成功！', icon: 'success' });
                onClose();
                onUpdated(false);
            } else {
                Toast.show({ content: response.data.msg, icon: 'fail' });
            }
        } catch (error) {
            Toast.show({ content: '操作失败，请联系管理员！', icon: 'fail' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Popup
            visible={visible}
            position='bottom'
            onMaskClick={onClose}
            bodyStyle={{ borderTopLeftRadius: 24, borderTopRightRadius: 24, maxHeight: '82vh', overflow: 'hidden' }}
            style={{ '--z-index': 1250 }}
        >
            <div className="lazy-signup-sheet">
                <div className="lazy-signup-header">
                    <button type="button" onClick={onClose}>取消</button>
                    <div>
                        <div className="lazy-signup-title">{isStatusChange ? '调整报名状态' : '为成员报名'}</div>
                        <div className="lazy-signup-subtitle">选择本场身份后一次确认</div>
                    </div>
                    <button type="button" className="primary" disabled={submitting} onClick={submit}>确认</button>
                </div>

                <div className="lazy-signup-content">
                    <div className="lazy-signup-person">
                        <img src={avatar} alt={user?.name || ''} />
                        <div>
                            <strong>{user?.name}</strong>
                            <span>{currentStatus}</span>
                        </div>
                    </div>

                    <div className="lazy-signup-section-title">选择报名身份</div>
                    <Selector columns={3} options={SIGNUP_OPTIONS} value={gameType === null ? [] : [gameType]} onChange={value => setGameType(value[0] ?? null)} />

                    {gameType === 0 && (
                        <>
                            <div className="lazy-signup-section-title">选择所属队伍</div>
                            <Selector columns={2} options={teams} value={gameTeam ? [gameTeam] : []} onChange={value => setGameTeam(value[0] || null)} />
                        </>
                    )}
                </div>
            </div>
        </Popup>
    );
};

export default LazySignupPopup;
